@if(!!loading) {
  <db-loading-screen [pageBlocker]="true"></db-loading-screen>
}@else{
  <db-api-reseller-pro  [user]="user" [currentSubscription]="currentSubscription" [demoUser]="demoUser"></db-api-reseller-pro>
}
